module.exports = __webpack_public_path__ + "img/精美模版@3x.01036105.png";